import { updateConfiguration } from '../../../../api/simple-project-service/configurations/updateConfiguration';
import { updatePublicConfiguration } from '../../../../api/simple-project-service/configurations/updatePublicConfiguration';
import Store from '../../../../interfaces/Store';
import { MultipleViolationsError, validationService } from '../../../../services/validationService';
import { NotificationFactory } from '../../../../utils/factories/notificationFactory';
import { ActionType } from '../../../actions';
import { addNotifications } from '../../../notifications/notifications.actions';
import {
  disableInteractions,
  enableInteractions,
} from '../../../suppressInteractions/suppressInteractions.actions';
import { updateDimensions } from '../../dimensions/dimensions.actions';
import { removeArticleFromConfiguration } from './removeArticleFromConfiguration';

const REMOVE_ARTICLE = 'removeArticle';

function dispatchError(dispatch, error: Error) {
  if (error instanceof MultipleViolationsError) {
    dispatch(addNotifications([NotificationFactory.multipleViolations(error.violations)]));
  } else {
    dispatch(addNotifications([NotificationFactory.customNegative(error.message)]));
  }
  dispatch(enableInteractions(REMOVE_ARTICLE));
}

export const removeArticle = (articleId: string, unselect = true) => {
  return async (dispatch, getState: () => Store, { getScene, loggedIn }) => {
    dispatch(disableInteractions(REMOVE_ARTICLE));

    if (!getState().configuration.articles.find((article) => article.id === articleId)) {
      console.error(`Article with id '${articleId}' is not in the store!`);
      return dispatch(enableInteractions(REMOVE_ARTICLE));
    }

    const articleToRemove = getState().configuration.articles.find(
      (article) => article.id === articleId,
    );
    const futureConfiguration = removeArticleFromConfiguration(
      getState().configuration,
      articleToRemove.id,
    );
    const validationAndLightingSetup = await validationService.validateAndGetLightingSetup(
      futureConfiguration,
    );
    if (validationAndLightingSetup instanceof Error) {
      return dispatchError(dispatch, validationAndLightingSetup);
    }

    dispatch({
      type: ActionType.REMOVE_ARTICLE,
      payload: {
        unsetSelectedArticleId: articleId,
        configuration: futureConfiguration,
        validationAndLightingSetup,
      },
    });

    getScene().removeArticle(articleId);
    unselect && getScene().unselect();

    dispatch(updateDimensions());

    dispatch(enableInteractions(REMOVE_ARTICLE));

    loggedIn
      ? updateConfiguration(getState().configuration)
      : updatePublicConfiguration(getState().configuration);
  };
};
